export default __webpack_public_path__ + "static/connect-apps-8a7e8f76e6277a349f159159f246b001.png";